var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentityFraudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "37px",
    viewBox: "0 0 25 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24.475 0 24.475 36.6456944 0 36.6456944"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Identity-Fraud",
    transform: "translate(-47.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(47.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-identity-fraud-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2381944,36.6456944 C5.47916667,36.6456944 0,31.1658333 0,24.4075 C0,20.5102778 1.82430556,17.0415278 4.66388889,14.7998611 L4.66319444,14.7998611 L4.66319444,8.36166667 C4.66319444,3.75055556 8.06111111,-0.000138888889 12.2381944,-0.000138888889 C16.4159722,-0.000138888889 19.8138889,3.75055556 19.8138889,8.36166667 L19.8138889,9.96166667 L19.8104167,9.96166667 C19.8104167,10.5102778 19.3861111,10.9554167 18.8493056,10.9977778 L18.8493056,11.0033333 L18.0930556,10.9963889 C17.5652778,10.9436111 17.1520833,10.5033333 17.1520833,9.96166667 L17.1520833,8.36166667 C17.1520833,5.21930556 14.9472222,2.66166667 12.2375,2.66166667 C9.52847222,2.66166667 7.32361111,5.21930556 7.32361111,8.36166667 L7.32361111,13.2005556 C7.32291667,13.2005556 7.32222222,13.2005556 7.32222222,13.20125 C8.82708333,12.5401389 10.4888889,12.1706944 12.2375,12.1706944 C13.9409722,12.1706944 15.5604167,12.5234722 17.0340278,13.1519444 C17.36875,13.3088889 18.7555556,13.9776389 19.8680556,14.8463889 C22.6743056,17.08875 24.475,20.5359722 24.475,24.4081944 C24.4756944,31.1658333 18.9979167,36.6456944 12.2381944,36.6456944",
    id: "Fill-1",
    fill: "#FBFBFD",
    mask: "url(#mask-identity-fraud-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityFraudIcon);
export default __webpack_public_path__ + "static/media/identity_fraud_icon.a1d9eac1.svg";
export { ForwardRef as ReactComponent };